/**
 * v3-catering — guest stepper, running total and request-form sync for the
 * catering page (sections/v3-catering.liquid, NOW-27 + request flow).
 *
 * Each [data-v3-catering-order] carries data-price (cents), data-min
 * (minimum guests) and the notice rule (data-notice-small days for up to
 * data-notice-threshold guests, data-notice-large days above). Guests can't
 * go below the minimum. The stepper keeps the request form's hidden Guests
 * and Total fields in step and moves the "Date needed" minimum to
 * today + notice. There is no Add to bag: catering is ordered by request.
 */
(() => {
  const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
  const locale = document.documentElement.lang || 'en-GB';
  const fmt = new Intl.NumberFormat(locale, { style: 'currency', currency });
  const money = (cents) => fmt.format(cents / 100);
  const dayLabel = new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  const pad = (n) => String(n).padStart(2, '0');
  const isoDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

  function setup(box) {
    if (box.dataset.v3CateringReady) return;
    box.dataset.v3CateringReady = 'true';
    const min = Math.max(1, parseInt(box.dataset.min, 10) || 1);
    const price = parseInt(box.dataset.price, 10) || 0;
    const noticeSmall = parseInt(box.dataset.noticeSmall, 10) || 4;
    const noticeLarge = parseInt(box.dataset.noticeLarge, 10) || 6;
    const threshold = parseInt(box.dataset.noticeThreshold, 10) || 8;
    const dec = box.querySelector('[data-v3-catering-dec]');
    const inc = box.querySelector('[data-v3-catering-inc]');
    const out = box.querySelector('[data-v3-catering-guests]');
    const total = box.querySelector('[data-v3-catering-total]');
    const fGuests = box.querySelector('[data-v3-catering-f-guests]');
    const fTotal = box.querySelector('[data-v3-catering-f-total]');
    const date = box.querySelector('input[type="date"]');
    const hint = date && document.getElementById(`${date.id}-hint`);
    let guests = min;

    const render = () => {
      out.textContent = guests;
      dec.disabled = guests <= min;
      total.textContent = `Total for ${guests} guests: ${money(price * guests)}`;
      if (fGuests) fGuests.value = String(guests);
      if (fTotal) fTotal.value = money(price * guests);
      if (date) {
        const notice = guests > threshold ? noticeLarge : noticeSmall;
        const earliest = new Date();
        earliest.setHours(0, 0, 0, 0);
        earliest.setDate(earliest.getDate() + notice);
        const minIso = isoDate(earliest);
        date.min = minIso;
        if (date.value && date.value < minIso) date.value = '';
        if (hint) hint.textContent = `Earliest date: ${dayLabel.format(earliest)} (${notice} days' notice for ${guests} guests).`;
      }
    };

    dec.addEventListener('click', () => { guests = Math.max(min, guests - 1); render(); });
    inc.addEventListener('click', () => { guests += 1; render(); });
    render();
  }

  const init = () => document.querySelectorAll('[data-v3-catering-order]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
